<div class="modal fade" role="dialog" [id]="'zintModal-'+ modalConfig.name" tabindex="-1">
  <div class="modal-dialog" [ngClass]="getModalSizeAndCenterClasses()" role="document">
    <div class="modal-content">
      @if (modalConfig.showHeaderRow) {
        <div class="modal-header">
          @if (modalConfig.title) {
            <h5 class="modal-title">{{modalConfig.title}}</h5>
          }
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      }      
      <div class="modal-body d-flex flex-column">
        @if (modalContent?.plainText) {
          <span class="line-break-text">{{modalContent.plainText}}</span>
        }
        @if (modalContent?.htmlElement) {
          <div [innerHTML]="modalContent.htmlElement | safe: 'html'"></div>
        }

        <ng-content select="[modalContent]"></ng-content>
        
        @if(modalConfig.showConfirmBtn){
          <button class="rounded-btn-base btn-p-md align-self-end mt-2" [ngClass]="modalConfig.confirmBtnClass || 'rounded-btn-light '" (click)="onConfirmClick()" data-bs-dismiss="modal">{{modalConfig.confirmBtnLabel || "OK"}}</button>
        }
      </div>
    </div>
  </div>
</div>

